// extracted by css-extract-rspack-plugin
export default {"usage":"SC0Bz","toggle":"EHbYV","chevron":"_4fic","open":"tfhuM","arg":"Rkqqu","active":"VkSi1","info":"L1viU","title":"Nkj7f","arguments":"vCv2w","documentationLink":"SyE87"};